import { type TagSeverity } from '@/components/chariot-ui';

/** The five score-derived severity buckets a RiskBadge can render. */
export type RiskBucket = 'critical' | 'high' | 'medium' | 'low' | 'info';

/**
 * Map a numeric risk score to a severity bucket.
 * Thresholds preserved from the legacy `getRiskScoreClasses` helper:
 * `≥90 critical · ≥70 high · ≥40 medium · ≥20 low · <20 info`.
 */
export function scoreToBucket(score: number): RiskBucket {
  if (score >= 90) return 'critical';
  if (score >= 70) return 'high';
  if (score >= 40) return 'medium';
  if (score >= 20) return 'low';
  return 'info';
}

/**
 * Map an explicit severity to a bucket. `exposure` has no dedicated status
 * colour; it shares the info ramp (matching RiskTag/TextRiskTag in
 * chariot-ui/Tag.tsx).
 */
export function severityToBucket(severity: TagSeverity): RiskBucket {
  return severity === 'exposure' ? 'info' : severity;
}
